// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExtendResponseDeadlineClaimDTO
 */
export interface ExtendResponseDeadlineClaimDTO {
    /**
     * The last day to respond, as YYYY-MM-DD
     * @type {string}
     * @memberof ExtendResponseDeadlineClaimDTO
     */
    responseDeadline: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendResponseDeadlineClaimDTO
     */
    reasonType: ExtendResponseDeadlineClaimDTOReasonTypeEnum;
    /**
     * Details of why the deadline is being extended
     * @type {string}
     * @memberof ExtendResponseDeadlineClaimDTO
     */
    reason: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ExtendResponseDeadlineClaimDTOReasonTypeEnum {
    PARTNERALLOWEDMORETIME = 'PARTNER_ALLOWED_MORE_TIME',
    REPOSITPROCESSFAILURE = 'REPOSIT_PROCESS_FAILURE'
}



